export const path = 'https://otvy.ru/api'